import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Footer from './components/Footer';

import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import GILog from './pages/GILog';
import Screening from './pages/Screening';
import InfoHub from './pages/InfoHub';
import ChildProfile from './pages/ChildProfile';
import Progress from './pages/Progress';
import Landing from './pages/Landing';
import PublicScreening from './pages/PublicScreening';
import Navbar from './components/Navbar';
import PublicNavbar from './components/PublicNavbar';
import ChildSummary from './pages/ChildSummary';

import About from './pages/About';

import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import { AdminProvider } from './context/AdminContext';

import ResetPassword from './pages/ResetPassword';

function PrivateRoute({ children }) {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" />;
}

function App() {
  const { user } = useAuth();
  return (
    <AdminProvider>
      <Router>
        <Routes>
          {/* Halaman Publik */}
          <Route path="/landing" element={<><PublicNavbar /><Landing /><Footer /></>} />
          <Route path="/public-info" element={<><PublicNavbar /><InfoHub /><Footer /></>} />
          <Route path="/public-screening" element={<><PublicNavbar /><PublicScreening /><Footer /></>} />
          <Route path="/child-summary/:childId" element={<ChildSummary />} />

          {/* Admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />

          {/* Auth */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* Privat */}
          <Route path="/" element={<PrivateRoute><Navbar /><Dashboard /><Footer /></PrivateRoute>} />
          <Route path="/log" element={<PrivateRoute><Navbar /><GILog /><Footer /></PrivateRoute>} />
          <Route path="/screening" element={<PrivateRoute><Navbar /><Screening /><Footer /></PrivateRoute>} />
          <Route path="/info" element={<PrivateRoute><Navbar /><InfoHub /><Footer /></PrivateRoute>} />
          <Route path="/child" element={<PrivateRoute><Navbar /><ChildProfile /><Footer /></PrivateRoute>} />
          <Route path="/progress" element={<PrivateRoute><Navbar /><Progress /><Footer /></PrivateRoute>} />

          <Route path="*" element={<Navigate to={user ? "/" : "/landing"} />} />

          <Route path="/reset-password" element={<ResetPassword />} />

          <Route path="/tentang" element={<About />} />
        </Routes>
      </Router>
    </AdminProvider>
  );
}

export default App;